import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersFormInstitution } from './types';

export const transformDataset = (values: FiltersFormInstitution): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codice: { value: otherValues.code },
    codiceIstat: { value: otherValues.istat },
    numeroUfficiStatoCivile: { value: otherValues.officeNumber, operation: Operation.EQUALS },
    nome: { value: otherValues.description },
    provincia: { value: otherValues.province },
    anpr: { value: otherValues.anpr, operation: Operation.EQUALS },
  };

  const ordersToTransform = orders || {};
  const ordersMapped = {
    codice: ordersToTransform.code,
    codiceIstat: ordersToTransform.istat,
    numeroUfficiStatoCivile: ordersToTransform.officeNumber,
    nome: ordersToTransform.description,
    provincia: ordersToTransform.province,
    anpr: ordersToTransform.anpr,
  };

  return `?${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
